/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentTime/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2IconEvent from 'DesignSystem/Svgs/Tysiav2IconEvent/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentTime({
  children,
  viewPath = "/App/Account/Chairs/Content/Appointments/Content/Appointment/AppointmentTime",
  isEarly,
  isOverdue,
  time
  
}) {
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtColorsGreen600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.600'
        })
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
  return (<React.Fragment
>
<div
  data-testid="AppointmentTime.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2IconEvent
  viewPath={`${viewPath}/Tysiav2IconEvent`}
 width={12}
 height={12}
 marginRight={2}
 fill={isEarly ? dtColorsGreen600 : isOverdue ? dtColorsRed600 : dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 weight="medium"
 color={isEarly ? dtColorsGreen600 : isOverdue ? dtColorsRed600 : dtColorsNeutral600}
 textOverflow="ellipsis"
 overflowX="hidden"
 overflowY="hidden"
 whiteSpace="nowrap"
 maxWidth={120}
 text={time}
/>
</div>
{children}
</React.Fragment>)
}